export default __webpack_public_path__ + "static/media/ESG_Report.b9fd3037.pdf";